import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto 1rem;
  overflow-y: hidden;
`;

export const Header = styled.header`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  margin-bottom: 16px;

  button{
    margin-left: 16px;
    margin-bottom: 16px;
  }
`;
